// extracted by mini-css-extract-plugin
export default {"result":"Td9a-","copy":"x6Fox"};